import React, { useContext, useMemo } from 'react'
import { GlobalContext } from '../context/globalContext'

const Balance = () => {
  const { state } = useContext(GlobalContext)
  const { transactions } = state

  const total = useMemo(() => {
    const amounts = transactions.map((t) => t.amount)
    return amounts.reduce((acc, item) => acc + item, 0)
  }, [transactions])
  return (
    <div>
      <h2>Your balance</h2>
      <h3>${total}</h3>
    </div>
  )
}

export default Balance
